module.exports = __webpack_public_path__ + "static/media/soccer.c145256e.svg";